'use strict';

var EventEmitter = require('eventemitter3');
var earcut = require('earcut');

"use strict";

exports.EventEmitter = EventEmitter;
exports.earcut = earcut;
//# sourceMappingURL=utils.js.map
